<template>
  <div class="loading">
    <transition name="loading-fade">
      <div
        v-show="loading"
        key="content"
        class="loading__content"
        :style="{ backgroundColor }"
      >
        <div v-if="label">
          <WParagraph size="large">{{ label }}</WParagraph>
        </div>
        <img class="loading__animation" :src="require('@/assets/heart.svg')" />
      </div>
    </transition>
    <slot />
  </div>
</template>

<script>
import { WParagraph } from '@alice-health/wonderland-vue'

export default {
  name: 'LoadingComponent',
  components: { WParagraph },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    label: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: var(--gl-spacing-05);

  &-fade-enter-active,
  &-fade-leave-active {
    transition: opacity 0.3s ease;
  }
  &-fade-enter-from,
  &-fade-leave-to {
    opacity: 0;
  }

  &__content {
    align-items: center;
    display: flex;
    justify-content: center;
    z-index: 10;
    flex-direction: column;
    gap: var(--gl-spacing-02);
  }

  &__animation {
    animation: 0.75s infinite ease-in-out beatHeart;
    width: 20px;
    height: 16px;
  }
}
</style>
